module.exports = __webpack_public_path__ + "static/img/service_bg1.b7d304e7.png";